// let basePath = "api";
// let basePath = "http://ywtb.sudytech.cn/imp"
let basePath = ""
if (process.env.NODE_ENV === "development") {
    basePath = "/api"
}
const baseurl = (window.baseurl || basePath) ;
const subPath = window.subPath || ""
// window.subPath = "/imp"

const urls = {
    //信息校验
    checkInfo: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/checkInfo.rst`,
    //绑定手机
    bindPhone: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/bindPhone.rst`,
    //绑定邮箱
    bindEmail: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/bindEmail.rst`,
    //设置密码
    resetPassword: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/resetPassword.rst`,
    //发短信
    sendSmsCode: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/sendSmsCode.rst`,
    //发送邮件验证码
    sendEmailCode: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/sendEmailCode.rst`,
    // 获取验证码
    getCode: `${baseurl}${subPath}/_control/validateimage`,
    // 获取配置
    getConfig: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/config.rst`,
    // 生成账号激活后绑定微信账号二维码
    generaCode: `${baseurl}${subPath}/_web/_apps/selfservice/api/wechat/bindQRCode.rst`,
    // 请求二维码地址和二维码图片信息
    bindQrCode: `${baseurl}${subPath}/_web/_apps/selfservice/api/wechat/bindQRCode.rst`,
    //判断微信是否绑定成功
    getBindState: `${baseurl}${subPath}/_web/_apps/selfservice/api/wechat/bindState.rst`,
    //账号激活完成后，查跳转的统一身份认证地址
    getRedirectURL: `${baseurl}${subPath}/_web/_apps/selfservice/api/activation/redirectURL.rst`,
}

export default urls;